import { customizeProductPages } from './landingPages'

const config = {

  customizeProductPages,

  customerProject: {
    key: 'sellsydemo',
    shopIds: [205],
    template: 'shop.mysellsy.de',
  },

  // Template-Elemente
  productLagerwareTopAlert: false,
  stockDeliveryTime: 3,
  couponDisplay:true,
  VorkasseDisplay:false,
  NachnahmeDisplay:false,
  RechnungDisplay:false,
  PayPalDisplay:false,
  DemoPaymentDisplay:true,

  // Strukturierte Daten: Standardwerte je Shop vor Launch pruefen.
  structuredData: {
    returns: {
      merchantReturnDays: 14,
      returnFees: 'https://schema.org/ReturnFeesCustomerResponsibility',
      returnMethod: 'https://schema.org/ReturnByMail',
      refundType: 'https://schema.org/FullRefund',
    },
    shipping: {
      destinationCountry: 'DE',
      handlingTime: { minValue: 0, maxValue: 1, unitCode: 'DAY' },
      shippingTypes: {
        1: { name: 'Warenpost', rate: 'deutschland' },
        10: { name: 'Paket-Versand', rate: 'deutschland' },
        12: { name: 'Paket-Versand Sperrgut', rate: 'deutschland' },
        20: { name: 'Speditions-Versand', rate: 'spedition' },
        30: { name: 'Speditions-Versand Sperrgut', rate: 'spedition' },
      },
      defaultShippingType: 10,
    },
  },
  
  // PayPal
  paypal: {
    live: {
      "client-id": 'AXFT046jeEqRBMjCrm_0ChBrOlGx5OMF2tX5U_lbZyxIqr6SUVlHibk_Ov2Hdor7bQop9G3dLbHNUYDj',
      //"data-client-token": "abc123xyz==",
    },
    dev: {
      "client-id": 'AXNo2j0t33R20Sdp5bu9ZzbMsyVMSpLoxqPozCky0t6GRRmo3YbCA3PPpFmmKNzMMDD1amQ96etxkoDA',
      //"data-client-token": "abc123xyz==",
    },
  },

  // Footer
  brands: [

    //36,  // Joop!
    //62,  // Essenza
    //61,  // Pip Studio
    //166, // Greengate

    //42,  // Bassetti
    34,  // Formesse
    160, // The Laundress
    189, // Bondi Wash

    203, // Meraki
    201, // Claus Porto
    190, // Björk & Berries
    196, // Le Jacquard Francais
    
  ]

} as const

export default config
